import React from 'react';
import { useNavigate } from 'react-router-dom';
import { brands, companyInfo } from '../mockData';

const Footer = () => {
  const navigate = useNavigate();

  const navLinks = [
    { name: 'Home', action: () => navigate('/') },
    { name: 'About', action: () => navigate('/about') },
    { name: 'Portfolio', action: () => navigate('/portfolio') },
    { name: 'Connect', action: () => navigate('/connect') }
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#FAFAFA] border-t border-black/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 md:py-8">

        {/* Brands left, Nav right */}
        <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {brands.map((brand) => {
              const url = brand.socials?.website;
              return url ? (
                <a
                  key={brand.slug}
                  data-testid={`footer-brand-${brand.slug}`}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-[#9CA3AF] hover:text-[#B8960C] transition-colors duration-300 font-light"
                >
                  {brand.name}
                </a>
              ) : (
                <span
                  key={brand.slug}
                  data-testid={`footer-brand-${brand.slug}`}
                  className="text-xs text-[#9CA3AF] font-light"
                >
                  {brand.name}
                </span>
              );
            })}
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 md:justify-end">
            {navLinks.map((link) => (
              <button
                key={link.name}
                data-testid={`footer-link-${link.name.toLowerCase()}`}
                onClick={link.action}
                className="text-xs text-[#9CA3AF] hover:text-[#B8960C] transition-colors duration-300 font-light"
              >
                {link.name}
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-black/5 pt-4">
          <p className="text-[#C0C0C0] text-[10px] font-light tracking-wide">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
